import React, {useEffect, useRef, useState} from "react";
import {summaryHeadDefault, summaryRowFormatting} from "../../../../helpers/utils/OrderDetailUtils";
import { formatValueAsDate} from "../../../../helpers/utils/DateUtils";
import moment from "moment";

interface SummarySectionProps {
    curAccount: any;
    setIsSavedResult: any;
    accounts: any;
    setAccounts: any;
    editable: boolean;
    showAccount: number;
    setUpdatedAccountIndexList: any;
}

export const SummarySection: React.FC<SummarySectionProps> = ({
                                                                  curAccount,
                                                                  setIsSavedResult,
                                                                  accounts,
                                                                  setAccounts,
                                                                  editable,
                                                                  showAccount,
                                                                  setUpdatedAccountIndexList,
                                                              }) => {
    const [expandTagsFirstCheck, setExpandTagsChecks] = useState(false);
    const accountAreaRef = useRef<(HTMLTextAreaElement | null)[]>([]);

    useEffect(() => {
        if (!expandTagsFirstCheck) {
            setExpandTagsChecks(true);

            accountAreaRef.current.forEach((ref, i) => {
                if (ref) {
                    ref.style.height = "auto";
                    ref.style.height =
                        ref.value !== "" && ref.value.length > 18
                            ? `${ref.scrollHeight}px`
                            : "34px";
                }
            });
        }
    }, [expandTagsFirstCheck]);

    return (
        <div className="col-lg-12 col-sm-12 mt-3 ">
            <div className="border border-highlight-3 bg-highlight-5 py-2 text-center text-text-0">
                <b>Tax Bill Summary</b>
            </div>
            <div className={"overflow-auto"}>
                <table className="w-full border border-highlight-3 ">
                    {summaryHeadDefault()}
                    <tbody>
                    {curAccount?.summaryList?.map((row: any, i: any) => (
                        row && (
                            <tr className=" bg-text-1 border-t border-surface-5" key={i}>
                                <td className="text-center">{row.collector}</td>
                                <td>
                  
                    <textarea
                        className="border-0 pt-1 pb-0  text-center placeholder"
                        value={row.collectorAccountNumber}
                        data-placeholder="..."
                        ref={(el) => (accountAreaRef.current[i] = el)}
                        onChange={(e) => {
                            if (editable) {
                                row.collectorAccountNumber = e.target.value;
                                setIsSavedResult(false);
                                setAccounts([...accounts]);
                                setUpdatedAccountIndexList((prev: number[]) =>
                                    prev.includes(showAccount) ? prev : [...prev, showAccount]
                                );
                                const textarea = accountAreaRef.current[i];
                                if (textarea) {
                                    textarea.style.height = "auto";
                                    textarea.style.height =
                                        textarea.value !== "" && textarea.value.length > 18
                                            ? `${textarea.scrollHeight}px`
                                            : "34px";
                                }
                            }
                        }}
                        readOnly={
                            !(row.collector !== "" && row.collector !== null && editable)
                        }
                    /> 
                                </td> 
                                <td className="text-center">
                                    {row.taxYear == null || row.taxYear === "" ? "-" : row.taxYear}
                                </td>
                                <td className="text-center">
                                    {summaryRowFormatting(row, "baseTax")}
                                </td>
                                <td className="text-center">
                                    {summaryRowFormatting(row, "baseDue")}
                                </td>
                                <td className="text-center">
                                    {summaryRowFormatting(row, "currentMonthDue")}
                                </td>
                                <td className="text-center">
                                    {summaryRowFormatting(row, "nextMonthTaxDue")}
                                </td>
                                <td className="text-center">
                                    {row.asOfDate == null || row.asOfDate === ""
                                        ? "-"
                                        :  moment(row.asOfDate).format("MM/DD/YYYY")}
                                </td>
                            </tr>
                        )
                    ))}

                    <tr className="bg-text-1 border-t border-surface-5">
                        <td/>
                        <td/>
                        <td className="text-center">
                            <b>Total Taxes:</b>
                        </td>
                        <td className="text-center">
                            {summaryRowFormatting(curAccount, "baseTaxTotal")}
                        </td>
                        <td className="text-center">
                            {summaryRowFormatting(curAccount, "baseTaxDueTotal")}
                        </td>
                        <td className="text-center">
                            {summaryRowFormatting(curAccount, "currentMonthTotal")}
                        </td>
                        <td className="text-center">
                            {summaryRowFormatting(curAccount, "nextMonthTotal")}
                        </td>
                        <td className="text-center">-</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
